import { Skeleton } from 'common/src/designSystem/components/skeleton';
import { PositionPermission } from 'common/src/graphql/permissions/dsl';
import { useTranslate } from 'common/src/util/dependencies/dependencies';
import * as React from 'react';
import { Field } from 'react-final-form';
import Group, { Label, Toggle } from './group';
import RoleFormBox from './roleFormBox';

export const CommunicationBox = ({ disabled }: { disabled?: boolean }) => {
    const translate = useTranslate();

    return (
        <RoleFormBox
            subtitle={translate('communication_a_64203')}
            title={translate('communication_05277')}
        >
            <Field name="role.positionPermissions">
                {({ input }) => (
                    <>
                        <Group>
                            <Label>{translate('Campaigns')}</Label>
                            <Toggle
                                disabled={disabled}
                                permission={PositionPermission.SEND_CAMPAIGNS}
                                value={input.value}
                                onChange={input.onChange}
                            >
                                {translate('envoyer_une_cam_35768')}
                            </Toggle>
                        </Group>
                    </>
                )}
            </Field>
        </RoleFormBox>
    );
};

export const CommunicationSkeletonBox = () => {
    const translate = useTranslate();

    return (
        <RoleFormBox
            subtitle={translate('communication_a_64203')}
            title={translate('communication_05277')}
        >
            <Group>
                <Label>{translate('Campaigns')}</Label>
                <Skeleton borderRadius="$1" css={{ gridColumn: 2 }} height={20} />
            </Group>
        </RoleFormBox>
    );
};
